<template>
  <div v-if="item" class="product" @click.stop="$router.push(`/goods/info/${item.productno}`)">
    <div
      class="product_act_in"
    >
      <div class="pic">
        <el-image :src="item.thumbnailsImage" lazy></el-image>
        <div v-if="item.canSaleCount <= 1" class="status-box">
          <div class="status">{{ lang.sold_out }}</div>
        </div>
      </div>
      <div class="cont">
        <div class="title">
          <div v-if="item.preferentiallabel" class="label">
            <span>{{ item.preferentiallabel }}</span>
          </div>
          <div v-if="item.maxlable" class="label" :style="{ background: item.maxlablebgcolor }">
            <span>{{ item.maxlable }}</span>
          </div>

          <span>{{ item.title }}</span>
        </div>
        <div class="price">
          <template v-if="item.isgift === 2 && item.limitedstates === 2">
            <div class="item-price original"><span>{{ unit }}</span>{{ item.price.toFixed(2) }}</div>
            <div class="item-price"><span>{{ unit }}</span>{{ item.limitedtimeprice.toFixed(2) }}</div>
          </template>
          <template v-else-if="item.isgift === 4">
            <div class="item-price">
              <span>{{ unit }}</span>{{ item.integralprice.toFixed(2) }} + {{ item.integral }}{{ lang.integral }}
            </div>
          </template>
          <template v-else>
            <template v-if="item.pricediscount">
              <div class="item-price original"><span>{{ unit }}</span>{{ item.price.toFixed(2) }}</div>
              <div class="item-price">
                <span>{{ unit }}</span>{{ item.pricediscount.toFixed(2) }}
              </div>
            </template>
            <template v-else>
              <div class="item-price">
                <span>{{ unit }}</span>{{ item.price.toFixed(2) }}
              </div>
            </template>
          </template>
        </div>
        <div class="bottom">
          <div
            class="add"
            :class="{ disabeld : item.canSaleCount <= 1 }"
          >{{ item.isgift === 4 || item.isgift === 2 && item.limitedstates === 2 || item.pricediscount ? lang.limit_buy : lang.add_cart }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getbuydetail } from '@/api/order'
export default {
  props: {
    item: {
      type: Object
    },
    vem: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      num: 1
    }
  },
  computed: {
    lang() {
      return this.$t('goods')
    },
    ...mapGetters(['isLogin', 'unit']),
    vemId() {
      return this.$route.query.vemId || ''
    }
  },
  methods: {
    async buy(item) {
      if (item.canSaleCount <= 1) {
        return
      }
      await this.$checkLogin()
      const params = {
        productno: item.productno,
        buynum: this.num,
        isgift: item.isgift === 2 ? 2 : 0
      }
      getbuydetail(params).then((res) => {
        if (res.code === 1) {
          this.$router.push({
            path: '/order/confirm',
            query: params
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.product {
  width: 288px;
  height: 110px;
  background: #ffffff;
  box-sizing: border-box;
  border-radius: 12px;
  box-shadow: 0px 0px 10px 0px #f1f4f9;
  .product_act_in {
    display: flex;
    align-items: center;
    width: 288px;
    height: 110px;
    -webkit-transition: all 0.2s linear;
    transition: all 0.2s linear;
    box-sizing: border-box;
  }
  &:hover {
    cursor: pointer;
    .product_act_in {
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      border-radius: 12px;
      margin-top: -3px;
    }
  }
  .pic {
    position: relative;
    width: 80px;
    height: 80px;
    margin-left: 15px;
    .status-box {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 80px;
      height: 80px;
      z-index: 99;
      background-color: rgba(51, 51, 51, 0.5);
      border-radius: 10px;
    }
    .status {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 60px;
      height: 60px;
      border-radius: 50%;
      border: 2px solid #fff;
      color: #fff;
      font-weight: bold;
      font-size: 15px;
    }
  }
  /deep/ img {
    width: 80px;
    height: 80px;
  }
  .cont {
    flex: 1;
    position: relative;
    padding: 0 15px 0 10px;
    width: 133px;
    .title {
      display: flex;
      flex-wrap: wrap;
      color: #000000;
      font-size: 14rpx;
      padding: 0 0 6px;
      span {
        flex: 1;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .label {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 2px 4px 0 0;
        height: 18px;
        padding: 0 4px;
        background-color: #c90000;
        border-radius: 4px;
        span {
          color: #fff;
          font-size: 10px;
        }
      }
    }
    .price {
      display: flex;
      align-items: flex-end;
      .item-price {
        &.original {
          font-size: 10px;
          color: #000;
          margin-right: 10px;
          text-decoration: line-through;
        }
        font-size: 16px;
        color: #ff0000;
        span {
          font-size: 12px;
          padding-right: 6px;
        }
      }
    }
    .bottom {
      padding-top: 12px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .add {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #ec9221;
        min-width: 80px;
        padding: 0 10px;
        box-sizing: border-box;
        height: 24px;
        line-height: 24px;
        border-radius: 12px;
        color: #ffffff;
        font-size: 12px;
        &.disabeld {
          background-color: #aaa;
        }
      }
    }
  }
}
/deep/ .el-input-number__increase,
/deep/ .el-input-number__decrease {
  top: 0;
  background: #aaa;
  border: 0;
  width: 20px;
  height: 20px;
  line-height: 20px;
  border-radius: 4px;
  font-size: 14px;
  color: #ffffff;
}
/deep/ .el-input-number--small {
  width: 70px;
  line-height: 24px;
}
/deep/ .el-input-number {
  .el-input {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-input__inner {
    padding: 0;
    width: 24px;
    height: 20px;
    line-height: 20px;
    border: 1px solid #aaa;
    color: #000;
    font-size: 12px;
  }
}
</style>